export default __webpack_public_path__ + "upload/metro.a0357ff8.svg";